const config = {
  env: window._env_.ENV,
  apiURL: window._env_.API_URL,
  apiURL2: window._env_.FORMBUILDER_URL,
  documentURL: window._env_.DOCVAULT_URL,
  jobDepartmentID: window._env_.EID_APPOINTMENT_PROCESS_ID
};
// const config = {
//   env: "uat",
//   apiURL: "https://aamergateway.azurewebsites.net",
//   apiURL2: "https://aamerformbuilder.azurewebsites.net",
//   documentURL: "https://aamerdocvault.azurewebsites.net"
// };

const CONFIG = config;

export default CONFIG;
